import React, { createContext } from "react";
import PropTypes from "prop-types";
import { createTheme, ThemeProvider } from "@mui/material";
export const AppContext = createContext({});

export const AppProvider = ({ children }) => {
	// Set Material UI Theme
	const theme = createTheme({
		palette: {
			primary: {
				main: "#003A50",
			},
			secondary: {
				main: "#EFF8F9;",
			},
		},
		typography: {
			fontFamily: "Chillax, sans-serif",
		},
		components: {
			MuiButton: {
				defaultProps: {
					size: "large",
				},
				styleOverrides: {
					root: {
						// borderRadius: "20px",
						// paddingLeft: "30px",
						// paddingRight: "30px",
					},
				},
			},
		},
	});

	return (
		<AppContext.Provider value={{}}>
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</AppContext.Provider>
	);
};

// props validation
AppProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
